goog.provide("shadow.js.shim.module$$mui$x_date_pickers$DateCalendar");
goog.provide("module$shadow_js_shim_module$$mui$x_date_pickers$DateCalendar");
shadow.js.shim.module$$mui$x_date_pickers$DateCalendar = shadow.js.nativeProvides["@mui/x-date-pickers/DateCalendar"] = shadow$bridge("@mui/x-date-pickers/DateCalendar");
module$shadow_js_shim_module$$mui$x_date_pickers$DateCalendar.default = shadow.js.shim.module$$mui$x_date_pickers$DateCalendar;
